<template>
    <v-dialog v-model="dialogShow" persistent width="600" >
        <v-card>
            <div style="height: 70px;width: 100%;border-bottom:1px solid #a6a6a6;">
                <v-layout class="ma-0" fill-height justify-space-between align-center>
                    <div style="font-size: 20px;line-height: 28px;color: black;margin-left: 22px">提示</div>
                    <div @click="closeDialog" style="font-size: 15px;color: #a6a6a6;margin-right: 27px;cursor: pointer" class="iconfontFamily"> &#xe60d;</div>
                </v-layout>
            </div>
            <div style="padding-top: 50px;display: flex;width: 100%">
                <div style="width: 236px;">
                    <v-layout column class="ma-0" align-center>
                        <v-avatar size="45">
                            <v-img :src="inviteInfo.inviteUserAvatar"></v-img>
                        </v-avatar>
                        <div style="margin-top: 12px;color: rgba(166, 166, 166, 1)">邀请人：{{inviteInfo.inviteUserNickName}}</div>
                    </v-layout>
                </div>
                <div style="width: 364px;padding-right: 20px">
                    <v-layout column class="ma-0" align-start>
                        <div style="margin-top: 20px;color: black;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">您已被邀请加入团队文件——
                            <v-tooltip top max-width="315" color="rgba(166, 166, 166, 0.5)">
                                <template v-slot:activator="{ on, attrs }">
                                    <span  v-on="on" v-bind="attrs">{{inviteInfo.fileName}}</span>
                                </template>
                                <span style="font-size: 14px;color: black;word-break: break-all">{{inviteInfo.fileName}}</span>
                            </v-tooltip>
                            </div>
                        <div style="margin-top: 15px;color: black">角色：{{roleToName(inviteInfo.role)}}</div>
                    </v-layout>
                </div>
            </div>
            <div style="padding-top: 50px;display: flex;width: 100%;align-items: center">
                <div class="iconfontFamily" style="font-size: 16px;color: rgba(166, 166, 166, 1);line-height: 22px;margin-left: 22px">&#xe68e;</div>
                <div style="font-size: 16px;color: rgba(166, 166, 166, 1);line-height: 22px;margin-left: 12px">确认后，您将以
                    {{inviteInfo.yourNickName}} 的身份加入协作，昵称可在团队管理中更改。</div>
            </div>
            <div style="padding-top: 52px;padding-bottom: 16px;display: flex;width: 100%;">
                <v-layout class="ma-0" justify-end>
                    <div  style="width: 100px;height: 35px;line-height: 35px;text-align: center;margin-right: 27px;background: rgba(30, 58, 138, 1);color: white;cursor: pointer"  @click="sureJoinTeam">确认加入</div>
                    <div  style="width: 100px;height: 35px;line-height: 35px;text-align: center;margin-right: 27px;background: rgba(245, 245, 245, 1);cursor: pointer"  @click="closeDialog">取消</div>
                </v-layout>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "InviteMemberDialog",
        props:['dialogShow','inviteCode'],
        data(){
            return{
                inviteInfo:{
                    "fileName": "团队文件测试",
                    "inviteUserAvatar": "https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202108301117000116048_thumb.png",
                    "inviteUserNickName": "创作者2727967",
                    "role": 3,
                    "yourNickName": "创作者2727967"
                }
            }
        },
        methods:{
            closeDialog(){
                this.$emit("closeInviteDialog")
            },
            getInviteDialog(){
                this.$axios.get('/authorApi/z-geo-team/getInvitedInfo',{
                    params:{
                        inviteCode:this.inviteCode
                    }
                }).then((res)=>{
                    if(res.data.status === 200){
                        this.inviteInfo = res.data.data
                    }else{
                        this.$emit("closeInviteDialog")
                        this.$store.state.snackbarShow=true
                        this.$store.state.snackbarText = "邀请链接已失效！"
                        this.$store.state.snackbarType = 'error'
                    }
                })
            },
            roleToName(val){
                const map={
                    1:'创建者',
                    2:'管理者',
                    3:'编辑者',
                }
                return map[val]
            },
            sureJoinTeam(){
                let data = new FormData
                data.append('inviteCode',this.inviteCode)
                this.$axios.post('/authorApi/z-geo-team/invitedIntoTeam',data)
                    .then((res)=>{
                        if(res.data.status === 200){
                           this.$emit("inviteIntoTeamOk",res.data.data)
                           // this.$emit("inviteIntoTeamOk")
                        }else if(res.data.status === 5604){
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = "协作者数量已达上限！"
                            this.$store.state.snackbarType = 'error'
                        }else if(res.data.status === 5602){
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = "邀请链接失效！"
                            this.$store.state.snackbarType = 'error'
                        }else if(res.data.status === 5601){
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = "加入团队失败！"
                            this.$store.state.snackbarType = 'error'
                        }else{
                            this.$store.state.snackbarShow=true
                            this.$store.state.snackbarText = "加入团队失败！"
                            this.$store.state.snackbarType = 'error'
                        }
                    })
            },
        },
        mounted() {
            //删除存储的邀请码
            if(window.localStorage.getItem('inviteCode'))
                window.localStorage.removeItem('inviteCode');
            this.getInviteDialog()
        }
    }
</script>

<style scoped>

</style>
